import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Container, Row, Col, Card, Form, InputGroup } from "react-bootstrap";
import Footer from "../FooterBn";
import "../styles/Teachers.css";

function Teachers() {
  const { id } = useParams(); // Get the institute ID from the route
  const navigate = useNavigate(); // Use navigate to redirect to the teacher profile
  const [institute, setInstitute] = useState(null); // Store institute data
  const [teachers, setTeachers] = useState([]); // Store teachers' data
  const [filteredTeachers, setFilteredTeachers] = useState([]); // Store filtered teachers
  const [error, setError] = useState(""); // Error state
  const [searchName, setSearchName] = useState(""); // Store search input

  // Fetch institute and teachers data
  useEffect(() => {
    const fetchInstituteAndTeachers = async () => {
      try {
        const instituteResponse = await axios.get(
          `https://server.goatteachers.com/api/institutes/${id}`,
        );
        console.log("Fetched institute data:", instituteResponse.data);
        setInstitute(instituteResponse.data); // Set institute data

        const teachersResponse = await axios.get(
          `https://server.goatteachers.com/api/institutes/${id}/teachers`,
        );
        console.log("Fetched teachers data:", teachersResponse.data);
        if (Array.isArray(teachersResponse.data.teachers)) {
          setTeachers(teachersResponse.data.teachers); // Set teachers data
          setFilteredTeachers(teachersResponse.data.teachers); // Initially, show all teachers
        } else {
          setError("Failed to load teachers data.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load institute and teacher data.");
      }
    };

    fetchInstituteAndTeachers(); // Fetch data when the component mounts or `id` changes
  }, [id]);

  const handleSearchByName = (event) => {
    const nameQuery = event.target.value.toLowerCase();
    setSearchName(nameQuery);

    // Filter teachers by name
    const filteredByName = teachers.filter((teacher) =>
      teacher.teacher_name.toLowerCase().includes(nameQuery),
    );

    setFilteredTeachers(filteredByName);
  };

  const handleTeacherClick = (teacherId) => {
    // Redirect to the teacher's profile page
    navigate(`/teacher/${teacherId}`);
  };

  if (error) {
    return <div>{error}</div>; // Show error if there is any
  }

  if (!institute) {
    return <p>Loading institute data...</p>; // Show loading text until the institute data is fetched
  }

  return (
    <div>
      <Container className="my-5">
        {/* Institute Name */}
        <h1 className="institute-name">
          {institute.name || institute.institute_name}
        </h1>

        {/* Attribution Section */}
        <p className="attribution">
          Data derived from publicly available information on{" "}
          <strong>{institute.name || institute.institute_name}</strong>’s
          official website. Goat Teachers is not affiliated with or endorsed by{" "}
          <strong>{institute.name || institute.institute_name}</strong>.
        </p>

        {/* Search and Filter */}
        <Row className="mb-4">
          <Col md={4}>
            {/* Search by Name */}
            <InputGroup className="mb-3">
              <Form.Control
                placeholder="Search by teacher name"
                value={searchName}
                onChange={handleSearchByName}
              />
            </InputGroup>
          </Col>
        </Row>

        {/* Teachers List */}
        <h2 className="teachers-heading">Faculty Members</h2>

        {/* Display "No teachers found" message below heading if filteredTeachers is empty */}
        {filteredTeachers.length === 0 ? (
          <p>No teachers found for this institute.</p>
        ) : (
          <Row>
            {filteredTeachers.map((teacher) => (
              <Col md={4} key={teacher.teacher_id} className="mb-4">
                <Card
                  className="teacher-card shadow-sm"
                  onClick={() => handleTeacherClick(teacher.teacher_id)}
                >
                  <Card.Body>
                    <Card.Title>{teacher.teacher_name}</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                      {teacher.designation}
                    </Card.Subtitle>
                    <Card.Text className="text-muted">
                      Department: {teacher.department}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>
      <Footer />
    </div>
  );
}

export default Teachers;
